export { default as SquareEmptySolidIcon } from './SquareEmptySolidIcon';
